import { Component, OnInit } from "@angular/core";
import { TokenImpService } from '../../../Services/ImplementacionServicios/token-imp';
import { LoginServiceImp } from '../../../Services/ImplementacionServicios/login-service-imp';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { HttpClient } from '@angular/common/http';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-menu-admin',
  templateUrl: './menu-admin.component.html',
  styleUrls: ['./menu-admin.component.css']
})
export class MenuAdminComponent implements OnInit {

  public nombre: string;

  constructor(
    private http: HttpClient,
    private token: TokenImpService,
    private loginSer: LoginServiceImp,
    private router: Router,
    private SpinnerService: NgxSpinnerService,
    private messageService: MessageService
  ) { }

  ngOnInit(): void {
    this.nombre = this.obtenerNombre();
  }

  obtenerNombre() {
    return this.token.obtenerNombresAdmin();
  }

  irInicio() {
    this.router.navigate(['FecyrWeb/gestion/homeMenu']);
  }

  irSolicitudes() {
    this.router.navigate(['FecyrWeb/gestion/gestion-pagare']);
  }


  irSeguridad() {
    this.router.navigate(['FecyrWeb/gestion/reiniciarClaveCliente']);

  }

  cerrarSesion() {
    this.messageService.clear();
    this.messageService.add({ key: 'cs', sticky: true, severity: 'warn', summary: '¿Está seguro de cerrar la sesión?', detail: 'Por favor confirmar el cierre de sesión' });
  }

  confirmarCierreSesion() {
    let codigoUsuario = this.token.getCodUserEmpleado();
    this.loginSer.cerrarSession(codigoUsuario.toString()).then(
      (response: any)=>{
        if (response.bRta) {
          this.token.clearStorage();
          this.router.navigate(['FecyrWeb/sesion/loginAdmin']);
        }
        else{
          this.messageService.add({ key: 'msgToast', severity: 'warn', summary: '¡Alerta!', detail: response.sMsj });
        }
      }
    );   
  }

  cancelarCierreSesion() {
    this.messageService.clear('cs');
  }
}
